import { useContext } from "react"
import { AppContext } from "../App"
import logo from '../assets/logo.png'
import logo_worded_only from '../assets/logo_worded_only.png'
import { MdArrowDropDown, MdBuild, MdDashboard, MdHome, MdHotel, MdHouse, MdMoney, MdOutlineAnalytics, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlineSpaceDashboard, MdPayments, MdPeople, MdShop, MdSubject, MdViewList } from "react-icons/md";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { GoPerson } from "react-icons/go";
import { IoMdCash } from "react-icons/io";


export default function SideBar(props) {

  const appContext = useContext(AppContext);



  return (
    <div
      className="SideBar"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar">

        {/*
        <div className="logo-holder">
          <img
            src={logo}
          />
        </div>
        */}
        
        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'dashboard'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'dashboard') || !appContext.navItem}
          
        >
          <MdDashboard className="icon" />
          <p className="text">Dashboard</p>
        </div>
      

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'patients'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'patients')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Patients</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'visitations'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'visitations')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Visitations</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'exam_rooms'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'exam_rooms')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Examination Rooms</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'laboratory'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'laboratory')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Laboratory</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'radiology_room'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'radiology_room')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Radiology Room</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'pharmacy'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'pharmacy')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Pharmacy</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'staff_management'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'staff_management')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Staff Management</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'billing'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'billing')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Billing</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'accounting'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'accounting')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">Accounting</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'system_settings'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'system_settings')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">System Settings</p>
        </div>

        <div
          className="pill"
          onClick={() => {
            appContext.navTo({
              item: 'my_account'
            })
            appContext.setIsSideBarOpen(false);
          }}
          data-active={(appContext.navItem === 'my_account')}
        >
          <SiGoogleclassroom className="icon" />
          <p className="text">My Account</p>
        </div>
        
        
        
      </div>
    </div>
  )
}